import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../firebase'; // Import your configured Firebase
import { 
  onAuthStateChanged, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword,
  signOut
} from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // --- SIGNUP FUNCTION ---
  async function signup(email, password, name) {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    // Save user's name and role to Firestore
    await setDoc(doc(db, "users", userCredential.user.uid), {
      name: name,
      email: email,
      role: 'user' // Default new users to 'user'
    });
    return userCredential;
  }

  // --- LOGIN FUNCTION ---
  async function login(email, password) {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    // Get user role from Firestore
    const userDoc = await getDoc(doc(db, "users", userCredential.user.uid));
    if (userDoc.exists()) {
      return userDoc.data().role; // Return 'admin' or 'user'
    }
    return 'user'; // Default to 'user' if no doc found
  }

  // --- LOGOUT FUNCTION ---
  function logout() {
    return signOut(auth);
  }

  // This listener manages the currentUser state for the whole app
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setCurrentUser({ ...user, ...userDoc.data() });
        } else {
          setCurrentUser(user);
        }
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    login,
    signup,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

